import Model from '../orm/Model'

import Student from './Student'
import User from './User'

export default class Note extends Model {

    static entity = 'notes'

    static fields() {
        return {
            id: this.attr(null),
            student_id: this.number(),
            student: this.belongsTo(Student, 'student_id'),
            message: this.attr(null),
            user_id: this.number(),
            user: this.belongsTo(User, 'user_id'),
            created_at: this.attr(null)
        }
    }

    static graphql = {
        all: {
            parameters: {
                student_uuid: 'String!',
                course_uuid: 'String'
            },
            include: ['user']
        },
        create: {
            type: 'createNote',
            parameters: {
                student_uuid: 'String!',
                course_uuid: 'String',
                message: 'String!'
            },
            include: ['user']
        }
    }
}
